import React, { useState } from 'react';
import styled from 'styled-components';
import {useTranslations} from "use-intl";

import { ModalProps } from '@tager/web-components';
import { Nullable } from '@tager/web-core';

import CloseButton from '@/components/modals/shared/CloseButton';
import { Header, HeaderTitle } from '@/components/modals/shared/styles';
import SuccessForm from '@/components/Forms/SuccessForm';
import { ProductCardFormType } from '@/components/ProductCard/ProductCardForm';
import OrderCard from '@/components/OrderCard';
import { useBodyPositionFixed } from '@/hooks/useBodyPositionFixed';

import CheaperFormRequest from './CheaperFormRequest';

type ExampleModalProps = ModalProps<{
  title: string;
  orderData: Nullable<ProductCardFormType & { id: number }>;
}>;

function CheaperForm({ innerProps, closeModal }: ExampleModalProps) {
  const [isFormClosed, setFormClosed] = useState(false);
  const { title, orderData } = innerProps;

  useBodyPositionFixed();

  const t = useTranslations();

  return (
    <Component>
      <Header>
        <HeaderTitle>{title}</HeaderTitle>
        <StyledCloseButton onClick={closeModal} />
      </Header>
      <Content>
        {isFormClosed ? (
          <SuccessForm
            title={t('forms.success_title')}
            text={t('forms.success_text')}
          />
        ) : (
          <>
            {orderData && <OrderCard product={orderData} />}
            <CheaperFormRequest
              product={orderData}
              setFormClosed={() => setFormClosed(true)}
            />
          </>
        )}
      </Content>
    </Component>
  );
}
export default CheaperForm;

const Component = styled.div`
  height: min(calc(var(--vh, 1) * 100), 80vh);
  min-width: min(100vw, 500px);
  padding-bottom: 15px;
  background: #fff;
  flex-shrink: 1;
  -webkit-overflow-scrolling: touch !important;
  overflow: auto !important;
  position: relative;
`;

const StyledCloseButton = styled(CloseButton)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 15px;
`;

const Content = styled.div`
  height: 100%;
  padding: 0 15px;
`;
